import React from 'react';

const FeaturedWiresContext = React.createContext();

const mapper = d => w => ((w.slug === d.slug || w.id === d.id) ? { ...w, ...d } : w);

const replacer = d => w => (w.id === d.prevId ? d.wire : w);

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'addWire':
      return { ...state, featured: [...state.featured, payload], trigger: 'add' };
    case 'replaceWire':
      return { ...state, featured: state.featured.map(replacer(payload)), trigger: 'replace' };
    case 'setWires':
      return { ...state, featured: payload || [], trigger: 'set' };
    case 'updateWire':
      return { ...state, featured: state.featured.map(mapper(payload)), trigger: 'update' };
    case 'removeWire':
      return { ...state, featured: state.featured.filter(w => w.slug !== payload.slug), trigger: 'remove' };
    case 'setInitial':
      return { ...state, initial: payload || [] };
    default:
      throw new Error();
  }
};

const defaultState = {
  featured: [],
  initial: [],
  trigger: null,
};

export default FeaturedWiresContext;
export {
  reducer,
  defaultState,
};
